// @flow

// Vendors
import React from 'react';

// Types
import { ProductType } from '../../types';
type Props = {
  product: ProductType
};

const ProductGridItem = ({ product }: Props) => (
  <div className="grid__col-xs-12 grid__col-md-6 grid__col-lg-4">
    <a href={product.url} className="card card--product">
      <div
        className="card__media"
        dangerouslySetInnerHTML={{ __html: product.thumbnail }}
      />
      <div className="card__body">
        <h3 className="card__title">{product.title}</h3>
        <p className="card__description">{product.meta.short_description}</p>
      </div>
      <span className="card__more">Learn More</span>
    </a>
  </div>
);

export default ProductGridItem;
